<template>
  <div class="main">
    <TabListCon :divType="divTypes"></TabListCon>
    <img src="../../static/imgs/bg1.jpg" class="img" />
    <div class="box">
      <div class="briefIntroductionMain">
        <img src="../../static/imgs/gsjs.jpg" class="jsimg" />
        <!-- <div class="titleName">铭安简介</div>
        <div class="briefIntroduction">
          <div class="briefIntroductionText">
            浙江铭安潮居智能科技有限公司（简称“浙江铭安”）是专注于城乡绿色建筑和绿色能源业务的产业互联网企业，作为2020年度区级重点招商引资项目落户杭州城市副中心临平新城中国建筑数字化产业园，政府产业基金亦持有公司股份。
          </div>
          <div class="briefIntroductionText">
            自创立以来，浙江铭安以“享受绿色生活的美好时光”为使命、以“成为绿色智能产业的领创者”为愿景，致力于打造乡村绿色人居和绿色用能全产业链综合型服务商。目前业务范围已覆盖浙江、江苏、安徽、江西等华东主要市场，累计完成建房面积逾59000平米，先后获得“雏鹰企业”、“区级小而美企业”、“省级科技型企业”、“全国轻钢别墅质量领先企业”等荣誉。
          </div>
        </div>
      </div>
      <div class="companyPhilosophyMain">
        <div class="companyPhilosophyCot">
          <div class="engText">VISION</div>
          <div class="philosophyText">愿景</div>
          <div class="philosophyMs">成为绿色智能产业的领创者</div>
        </div>
        <div class="companyPhilosophyCot">
          <div class="engText">MISSION</div>
          <div class="philosophyText">使命</div>
          <div class="philosophyMs">成为绿色智能产业的领创者</div>
        </div>
        <div class="companyPhilosophyCot">
          <div class="engText">VALUE</div>
          <div class="philosophyText">价值观</div>
          <div class="philosophyMs">诚信｜高效｜共创｜共赢</div>
        </div>-->
      </div>
      <div>
        <video src="https://macj.oss-cn-hangzhou.aliyuncs.com/%E5%AE%A3%E4%BC%A0%E7%89%87.mp4" controls
          class="embed"></video>
        <!-- <embed src="intro.swf" class="embed"> -->
      </div>
      <img src="../../static/imgs/ywfw.jpg" class="jsimg" />
      <img src="../../static/imgs/hxys.jpg" class="jsimg" />
      <img src="../../static/imgs/fzgh.jpg" class="jsimg" />
      <!-- <div class="titleName">铭安优势</div>
      <img src="../../static/imgs/ys.png" class="imgBackg" />
      <div class="titleName">发展规划</div>
      <div class="briefIntroductionText">
        未来公司将整合吸收相关产业链资源，不断研发推出新的清洁用能产品，形成绿色住宅、智慧生活的农村应用新场景！这段文字可以加长这段文字可以加长这段文字可以加长这段文字可以加长这段文字可以加长这段文字可以加长这段文字可以加长这段文字可以加长这段文字可以加长这段文字可以加长。
      </div> -->
      <!-- <img src="../../static/imgs/fzgh.png" class="imgBackg" /> -->
      <div class="titleName">资质荣誉</div>
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="item in listData" :key="item.imgUrl" style="display: flex;align-items: center;">
          <img :src="item" alt="" class="swiper-slide-img" width="100%" height="100%"
            style="display: block;" /></swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <!-- <div class="actionIcon">
        <div class="icons">
          <img src="../../static/imgs/ButtonLeft .png" class="btnImgs" @click="handleLeft()" />
          <img src="../../static/imgs/ButtonRight.png" class="btnImgs" @click="handleRight()" />
        </div>
      </div> -->
    </div>
    <BottomContentCon></BottomContentCon>
  </div>
</template>
<script>
import TabListCon from "../../components/TabList/index.vue"
import BottomContentCon from "../../components/BottomContent/index.vue"
import { ImagePreview } from 'vant';
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "Home",
  data() {
    return {
      swiperOption: {
        slidesPerView: 3,
        loop: true,
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
      },
      timer: null,  // 定时器（方便清除）
      listData: [
        require('../../static/imgs/zs1.png'),
        require('../../static/imgs/zs2.png'),
        require('../../static/imgs/zs3.png'),
        require('../../static/imgs/zs4.png'),
        require('../../static/imgs/zs5.png'),
        require('../../static/imgs/zs6.png'),
        require('../../static/imgs/zs7.png'),
        require('../../static/imgs/zs8.png'),
        require('../../static/imgs/zs9.png'),
        require('../../static/imgs/zs10.png'),
        require('../../static/imgs/zs11.png'),
        require('../../static/imgs/zs12.png'),
        require('../../static/imgs/zs13.png'),
        require('../../static/imgs/zs14.png'),
        require('../../static/imgs/zs15.png'),
        require('../../static/imgs/zs16.png'),
      ],
      // divTypes: '2',//顶部Tab组件的index值
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    console.log("this is current swiper instance object", this.swiper);
    // this.swiper.slideTo(3, 1000, false);
  },
  components: {
    TabListCon, BottomContentCon, swiper,
    swiperSlide
  },
  created() {
  },
  methods: {
    //点击滚动条向右滚动  好TM难写  有个更好的办法 果然还得加定时器顺溜 早知道不做双端了
    handleLeft() {
      // const dataBar = document.querySelector('.swiper');
      // dataBar.scrollTo({  不好用不好用 移动端适合
      //   left: dataBar.scrollLeft - dataBar.clientWidth,
      //   behavior: 'smooth'
      // });

      // 保存滚动盒子左侧已滚动的距离  顺滑加定时器  写原生好累
      let left = this.$refs.wrapperCon.scrollLeft
      console.log('1111', left)
      let num = 0
      clearInterval(this.timer)
      this.timer = null
      this.timer = setInterval(() => {
        //   !left:已经滚动到最左侧   果然还得加定时器
        //   一次性滚动距离（可调节）
        if (!left || num >= 300) {
          // 停止滚动
          clearInterval(this.timer)
          this.timer = null
          return
        }
        // 给滚动盒子元素赋值向左滚动距离
        this.$refs.wrapperCon.scrollLeft = left -= 30
        // 保存向左滚动距离（方便判断一次性滚动多少距离）
        num += 30
      }, 20)
      // 20：速度（可调节）

    },
    //图片预览
    getImg(images, index) {
      ImagePreview({
        images: this.listData,
        showIndex: true,
        loop: false,
        startPosition: index,
        closeable: true,
      });
    },
    handleRight() {
      //这个效果不行 写原生真累
      // const dataBar = document.querySelector('.swiper');
      // dataBar.scrollTo({
      //   left: dataBar.scrollLeft + dataBar.clientWidth,
      //   behavior: 'smooth'
      // });
      // 保存滚动盒子左侧已滚动的距离
      let left = this.$refs.wrapperCon.scrollLeft
      // 保存元素的整体宽度
      let scrollWidth = this.$refs.wrapperCon.scrollWidth
      // 保存元素的可见宽度
      let clientWidth = this.$refs.wrapperCon.clientWidth
      let num = 0
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        // 已经滚动距离+可见宽度
        // left+clientWidth>=scrollWidth：滚动到最右侧
        // num>=300一次性滚动距离
        if (left + clientWidth >= scrollWidth || num >= 300) {
          clearInterval(this.timer)
          return
        }
        // 给滚动盒子元素赋值向左滚动距离
        this.$refs.wrapperCon.scrollLeft = left += 30
        // 保存向左滚动距离（方便判断一次性滚动多少距离）
        num += 30
      }, 20)
      // 20：速度（可调节）
    }

  }
};
</script>

<style scoped>
video::-webkit-media-controls-fullscreen-button {
  display: none;
}

video::-webkit-media-controls-play-button {
  display: none;
}

video::-webkit-media-controls-timeline {
  display: none;
}

video::-webkit-media-controls-current-time-display {
  display: none;
}

video::-webkit-media-controls-time-remaining-display {
  display: none;
}

video::-webkit-media-controls-mute-button {
  display: none;
}

video::-webkit-media-controls-toggle-closed-captions-button {
  display: none;
}

video::-webkit-media-controls-volume-slider {
  display: none;
}

video::-webkit-media-controls-enclosure {
  display: none;
}

/deep/.swiper-wrapper {
  display: flex;
  align-items: center;
}

.jsimg {
  width: 100%;
}

.actionIcon {
  margin-top: 60px;
  margin-bottom: 100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 100px
}

.btnImgs {
  width: 108px;
  height: 108px;
}

.icons {
  width: 420px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}


.swiper {
  margin-bottom: 120px;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}

.swiper::-webkit-scrollbar {
  display: none
}

/deep/.van-swipe-item {
  margin-right: 24px;
  width: 400px;
}

.imgSwiper {
  /* margin-right: 24px; */
  width: 400px;
  height: 100%;
  margin-right: 36px;
}


.imgBackg {
  width: 1600px;
  height: 940px;
  display: block;
  margin: 0 auto;
  margin-top: 76px;
  margin-bottom: 120px;
}

.embed {
  margin-top: 80px;
  margin-bottom: 120px;
  width: 1604px;
  height: 900px;
}

.companyPhilosophyMain {
  margin-top: 112px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.philosophyMs {
  color: #333333;
  font-size: 27px;
  line-height: 54px;
}

.philosophyText {
  color: #114035;
  font-size: 40px;
  font-weight: bold;
  line-height: 80px;
  width: 216px;
  margin: 0 auto;
  text-align: center;
  border-bottom: 2px solid #114035;
}

.engText {
  font-size: 24px;
  color: #999999;
}

.companyPhilosophyCot {
  width: 448px;
  text-align: center;
}

.briefIntroductionMain {
  background-image: url('../../static/imgs/jjbg.png');
  background-repeat: no-repeat;
  background-size: 100%;
}

.briefIntroductionText {
  font-size: 24px;
  color: #6D6D6D;
  line-height: 44px;
  margin-bottom: 48px;
}

.titleName {
  color: #333;
  font-size: 64px;
  text-align: center;
  font-weight: bold;
  margin-bottom: 88px;
}

.box {
  padding: 160px 120px 0 120px;
}

.text {
  color: rgba(255, 255, 255, 0.8);
  font-size: 40px;
}

.title {
  color: #fff;
  font-size: 80px;
}

.titleText {
  padding: 145px;
  width: 1500px;
  margin-top: -450px;
}

.img {
  width: 100%;
  height: 620px;
}
</style>